var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThirdBlockWave2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1120,
    height: 713,
    viewBox: "0 0 1120 713",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1074.91 282.025C990.372 312.843 941.719 25.1182 883.986 46.1657C824.184 67.9674 1015.61 495.891 951.552 519.244C890.037 541.67 774.144 128.932 712.515 151.4C653.152 173.042 816.807 525.645 752.529 549.079C691.333 571.389 602.257 234.318 540.987 256.655C482.398 278.014 627.423 551.966 553.562 578.893C479.701 605.82 437.639 347.109 377.167 369.155C319.989 390 421.782 585.019 368.068 604.601C322.463 621.227 280.538 447.797 230.566 466.015C180.594 484.233 250.427 625.323 206.459 641.352C166.544 655.903 140.374 539.249 104.596 552.292C68.8191 565.335 123.907 648.539 78.2869 665.171C67.2498 669.195 58.9543 667.019 45.0015 656.186",
    stroke: "url(#paint0_linear_1787_44155)",
    strokeWidth: 90,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1787_44155",
    x1: 27.2058,
    y1: 607.373,
    x2: 671.468,
    y2: 372.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdBlockWave2);
export default __webpack_public_path__ + "static/media/third_block_wave_2.fdc155dfadc1342d83c0de61ae800746.svg";
export { ForwardRef as ReactComponent };